<template>
  <div class="full-page-layout" :class="$config.project">
    <div class="container image-container">
      <div class="row">
        <div class="course-info" :class="$config.project === 'site' ? 'offset-1 col-4' : 'col-5'">
          <div class="heading col">
            <div class="label-main-yellow">
              <img src="../assets/svg/icon-star.svg"> Upcoming
            </div>
            <p class="h3">
              {{ course.name }}
            </p>
            <p class="instructor hero-text">
              with {{ course.instructor }}
            </p>
            <p class="hero-text course-descr">
              {{ course.description }}
            </p>
            <div class="course-launch-time">
              <p>Course launch in</p>
              <div v-if="course.launchDate" class="launch-time">
                <p class="month">
                  {{
                    new Date(course.launchDate).toLocaleString('en-GB', { month: "short" })
                  }}
                </p>
                <p class="year">
                  {{
                    new Date(course.launchDate).toLocaleString('en-GB', { year: "numeric" })
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wall" :style="{ backgroundImage: `url(${getInstructorImg(course.mainImage)})` }" />
  </div>
</template>

<script>
export default {
  props: {
    course: { type: Object, default: () => {} },
  },
  methods: {
    getInstructorImg(img) {
      if (process.client) {
        return `${this.$config.imagesUrl}/upcoming-courses/${img}`;
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.full-page-layout {
  background-color: var(--main-dark);
  position: relative;
  overflow: hidden;

  .wall {
    position: absolute;
    right: 0;
    top: 0;
    height: 650px;
    left: 0;
    z-index: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    image-rendering: -webkit-optimize-contrast;

    &:after {
      background: linear-gradient(90deg, rgba(0, 12, 31, 0.94) 0%, var(--main-dark) 0.01%, rgba(0, 12, 31, 0.98) 56.77%, rgba(0, 12, 31, 0) 100%);
      content: '';
      left: -325px;
      height: 650px;
      top: 0;
      position: absolute;
      width: 650px;
      z-index: 0;
    }

    img {
      height: 650px;
    }
  }

  &:before,
  &:after {
    content: '';
    left: 0;
    position: absolute;
    width: 100%;
    z-index: 2;
  }

  &:before {
    background: linear-gradient(180deg, rgba(0, 12, 31, 0.8) 0%, rgba(0, 12, 31, 0) 100%);
    background: linear-gradient(180deg, var(--main-dark) 0%, rgba(0, 12, 31, 0) 100%);
    height: 110px;
    top: 0;
  }

  &:after {
    bottom: 0;
    background: linear-gradient(360deg, var(--main-dark) 0%, rgba(0, 12, 31, 0) 100%);
    height: 200px;
  }

  .container {
    align-items: center;
    min-height: 380px;
    padding-top: 80px;

    &.image-container {
      height: 650px;
    }

    .row {
      align-items: center;
      height: 100%;

      > div {
        height: inherit;
        display: flex;
        align-items: center;
        position: relative;
        color: var(--main-light);
        z-index: 5;
        min-height: 380px;

        h3 {
          margin: 0;
          color: var(--main-light);
          white-space: nowrap;
        }

        .h3 {
          font-size: 38px;
        }

        .label-main-yellow {
          margin-bottom: 12px;
        }

        .hero-text {
          margin: 0;
          color: var(--main-light);

          &.instructor {
            font-weight: 700;
            margin-bottom: var(--spacing-20);
          }

          &.course-descr {
            color: var(--main-light-shade-4);
            display: block;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 167%;
            margin: var(--spacing-8) 0 var(--spacing-28) 0;
            width: 95%;
            font-weight: 400;
          }
        }

        .course-launch-time {
          position: relative;

          p:first-of-type {
            margin: 0;
            margin-bottom: var(--spacing-4);
            font-size: 14px;
            color: var(--main-light-shade-4);
            font-weight: 500;
          }

          .launch-time {
            background: var(--main-dark-shade-2);
            padding: var(--spacing-sm);
            float: left;
            width: 132px;
            height: 100px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-radius: 4px;
            position: relative;

            &:before {
              content: '';
              left: 4px;
              right: 4px;
              background-color: #242E3E;
              height: 40px;
              z-index: -1;
              position: absolute;
              bottom: -6px;
              border-radius: 4px;
            }

            &:after {
              content: '';
              left: 8px;
              right: 8px;
              background-color: #141F31;
              height: 40px;
              z-index: -2;
              position: absolute;
              bottom: -12px;
              border-radius: 4px;
            }

            p {
              margin: 0;
              margin-bottom: var(--spacing-4);

              &.month {
                font-size: 28.43px;
                text-align: center;
                color: var(--main-light);
              }

              &.year {
                font-size: 14px;
                text-align: center;
                color: var(--main-light-shade-4);
              }
            }
          }
        }

        &.mt {
          margin-top: var(--spacing-80);
        }
      }
    }
  }

  &.lms {
    .container {
      padding-top: 0;

      &.image-container {
        height: 544px;
      }

      .row {
        > div {
          h1 {
            margin: 0 auto var(--spacing-8);
          }
        }
      }
    }

    .wall {
      height: 544px;

      &:after {
        height: 544px;
      }
    }
  }

  @include bp($bp-mobile) {
    &:before {
      background: linear-gradient(180deg, var(--main-dark) 0%, rgba(0, 12, 31, 0.76) 37.5%, rgba(0, 12, 31, 0) 100%);
      height: 100px;
    }

    &:after {
      display: none;
    }

    .wall {
      background-position: 73%;
      background-repeat: no-repeat;
      background-size: cover;
      height: 540px;
      width: 100%;

      img {
        height: 450px;
        left: 0;
        transform: translateX(-50%);
      }

      &:after {
        background: linear-gradient(0deg, var(--main-dark) 0%, rgba(0, 12, 31, 0) 100%);
        bottom: auto;
        top: 364px;
        left: 0;
        height: 176px;
        width: 100%;
      }
    }

    .container.image-container {
      height: 100% !important;

      .row > div {
        align-items: flex-end;
        padding-bottom: 30px;
      }
    }

    &.site {
      height: 812px;

      .container .row > div {
        padding-bottom: var(--spacing-44);

        .h3 {
          font-weight: bold;
          font-size: 38px;
          line-height: 45px;
        }
      }
    }

    &.lms {
      height: 748px;

      .container.image-container {
        .row > div h1 {
          font-size: 38px;
          line-height: 45px;
        }
      }

      .wall {
        height: 540px;

        &:after {
          height: 176px;
        }
      }
    }
  }

  @include bp($bp-phone) {
    .container .row > div {
      a,
      .btn-primary {
        width: 100%;
      }
    }
  }
}

.fa {
  .full-page-layout {
    .container {
      .row {
        > div {
          .h3 {
            line-height: 110%;
          }

          .course-launch-time {
            .launch-time {
              background: var(--background-700);

              &:before {
                background-color: var(--main-dark-light-2);
              }

              &:after {
                background-color: var(--main-dark-light-1);
              }
            }
          }
        }
      }
    }
  }
}
</style>
